/* eslint-disable import/order */
/* eslint-disable camelcase */
import { sentenceCase } from 'change-case';
import { useState, useCallback, useEffect } from 'react';
// @mui
import { useTheme } from '@mui/material/styles';
import {
  Card,
  Table,
  Avatar,
  Button,
  Container,
  Typography,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  IconButton
} from '@mui/material';
// routes
import axios, { getErrorMessage } from 'utils/axios';
import useIsMountedRef from 'hooks/useIsMountedRef';
import CRUD from 'utils/Crud';
import { fDate, fDateTime } from 'utils/formatTime';
import { PATH_DASHBOARD } from '../../routes/paths';
// hooks
import useSettings from '../../hooks/useSettings';
import { useSnackbar } from 'notistack';
// components
import Page from '../../components/Page';
import Iconify from '../../components/Iconify';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';
// sections
import { DataGrid } from '@mui/x-data-grid';
import { fNumber } from 'utils/formatNumber';
import { LoadingButton } from '@mui/lab';
import CustomGridToolbar from 'components/CustomGridToolbar';
import SearchQueryDailog from 'sections/@dashboard/SearchQueryDailog';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import ProfileDialog from 'sections/@dashboard/user/ProfileDialog';
import Label from 'components/Label';
import ViewJSONDailog from 'sections/@dashboard/ViewJSONDailog';


export default function CruiseSendingHistory() {
  // const theme = useTheme();
  const { themeStretch } = useSettings();
  const isMountedRef = useIsMountedRef();
  // const [modal, setModal] = useState({open:false, user:{}});
  const [sort, setSort] = useState({field:'id', order:'desc',page_size:100,page:0});
  const [data, setData] = useState({data:[],current_page:1,total_pages:null,total_size:0,page_size:0});
  const [state,setState] = useState({loading:false,loadComplete:false,error:null});
  // const [query,setQuery] = useState({});
  const [dailog,setDailog] = useState({open:false,query:"",});
  const [profileDialog,setProfileDialog] = useState({open:false,user:"",});
  const [search,setSearch] = useState({open:false,query:"", list:[]});
  const [json,setJSON] = useState({open:false,data:{}});
  const { enqueueSnackbar } = useSnackbar();
  const theme = useTheme();


  useEffect(() => {
    getInitData();
  }, []);

  return (
    <Page title="Cruise History">
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading="Cruise Sending History"
          links={[
            { name: 'Cruise Center', href: PATH_DASHBOARD.cruiseCenter.root },
            { name: 'Cruise History' },
          ]}
        />

        {!state.loading && state.error !=null && (
          <Card>
            <Box padding={10} display={"flex"} justifyContent={"center"}>
            <p>Error {state.error} </p>
            </Box>
          </Card>
        )}

        <Card>
          {search.open && 
          <Box sx={{display:"flex", alignContent:"right", justifyContent:"space-between", width:"100%", padding:2}}>
            <p>Showing results for: {search.query}</p>
            <LoadingButton sx={{mr:2}}
              startIcon={<Iconify icon={'carbon:close-filled'} />}
              loading={state.loading} 
              onClick={()=> setSearch({...search, open:false})}
               variant='outlined' color="error">
                Close search
            </LoadingButton>
          </Box>}
          {!search.open && 
            <Box sx={{display:"flex", alignContent:"right ", justifyContent:"end", width:"100%", padding:2}}>
              
              <FormControl sx={{width:180,ml:2}}>
              <TextField id="user_id_field" 
                variant='outlined' 
                value={sort.user_id}
                onChange={(e)=> setSort({...sort,user_id:e.target.value})}
                label="User I.D" />
            </FormControl>
            <FormControl sx={{ml:2,width:180}}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker 
                  value={sort.start_date}
                  label="From date"
                  onChange={(newValue) => setSort({...sort,start_date:newValue})}
                  renderInput={(params) => <TextField {...params} size="small" fullWidth />}
                />
              </LocalizationProvider>
            </FormControl>
            <FormControl sx={{ml:2,width:180}}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker 
                  value={sort.end_date}
                  label="To date"
                  onChange={(newValue) => setSort({...sort,end_date:newValue})}
                  renderInput={(params) => <TextField {...params} size="small" fullWidth />}
                />
              </LocalizationProvider>
            </FormControl>
            <FormControl sx={{ml:2,width:180}}>
                <InputLabel id="demo-simple-select-label2">Sort date</InputLabel>
                <Select
                  labelId="demo-simple-select-label2"
                  label="Sort balance"
                  value={sort.order}
                  onChange={(e)=> setSort({...sort,order:e.target.value})}
                >
                  {[
                    {v:'asc',n:"Ascending"},
                    {v:'desc',n:"Descending"},
                    ].map((opt,i) => (
                  <MenuItem key={i} value={opt.v}>{opt.n}</MenuItem>
                  ))}
                </Select>
              </FormControl>
              <LoadingButton loading={state.loading} onClick={()=> getInitData()}
                sx={{ml:2}} variant='outlined' color="secondary">
                  Apply changes
              </LoadingButton> 
              
            </Box>}

          <Box sx={{ height: 850, width: '100%' }}>
            <DataGrid
              rows={search.open ? search.list : data.data}
              columns={[
                {
                  field: 'name',
                  headerName: 'User',
                  width: 220,
                  editable: false,
                  renderCell: (params) => (
                    <>
                      <IconButton color="primary" onClick={()=> setProfileDialog({open:true,user:{user_id:params.row.user_id}}) }>
                        <Iconify icon={'ph:user-thin'} size="small" sx={{width:25,height:25}} />
                      </IconButton>
                      <Typography variant="subtitle2">
                        {params.row.first_name} {params.row.last_name}
                      </Typography>
                    </>
                  ),
                  valueGetter: (params) => `${params.row.first_name} ${params.row.last_name}`
                },
                {
                  field: 'status',
                  headerName: 'Status',
                  width: 180,
                  editable: false,
                },
                {
                  field: 'created_at',
                  headerName: 'Created at',
                  width: 180,
                  editable: false,
                  valueGetter: (params) => fDate(params.value),
                },
                {
                  field: "actions",
                  type: "actions",
                  align: "right",
                  width: 280,
                  headerName: "Actions",
                  getActions: (params) => [
                    <Button 
                    key={1}
                      variant='text' color="error"
                      onClick={()=> {
                        setJSON({open:true,data:params.row});
                      }}
                      startIcon={<Iconify icon={'eva:edit-fill'} /> }
                      >
                        View Payload
                    </Button>
                  ],
                },
              ]}
              
              loading={state.loading}
              checkboxSelection
              disableRowSelectionOnClick
              components={{ Toolbar: CustomGridToolbar }}
              disableSelectionOnClick

              paginationMode="server"
              rowCount={data.total_size}
              page={data.current_page - 1}
              rowsPerPage={data.data.length}
              onPageChange={(newPage)=> {
                setSort({...sort, page:newPage + 1});
                getInitData(newPage + 1);
              }}
              pageSize={data.page_size}
              onPageSizeChange={(newPage) => setSort({...sort, page_size:newPage})}
              rowsPerPageOptions={[]}
              
            />
          </Box>
        </Card>
      </Container>

      {profileDialog.open &&  <ProfileDialog
        user={profileDialog.user}
        refresh
        handleClose={()=>{
          setProfileDialog({open:false});
        }}
         />}

        {json.open &&  <ViewJSONDailog
            data={json.data}
            handleClose={()=>{
              setJSON({open:false});
            }}
        />}

    </Page>
  );

  async function getInitData(page = null) {
    
    setState({...state,loading:true,loadComplete:false,error:null});

    const sdate = sort.start_date ?  new Date(sort.start_date).toDateString() : '';
    const edate = sort.end_date ?  new Date(sort.end_date).toDateString() : '';

    try {
      let str = `?sort_order=${sort.order}&page=${page || sort.page}&page_size=${sort.page_size}&user_id=${sort.user_id || ''}`;
      str+= `&start_date=${sdate}&end_date=${edate}`;

      const response = await axios.get(CRUD.cruise.history+str);

      if (isMountedRef.current) {
        setData(response.data);
      }
      setState({...state,loading:false,loadComplete:true,error:null})
    } catch (error) {
      // console.error(error);
      setState({...state,loading:false,loadComplete:false,error: getErrorMessage(error)})
    }
  };


}
